import React from 'react';
import PropTypes from 'prop-types';
import BaseButton from '../../../../modules/react/components/stateless/Button';
import useCurrentPage from '../../../hooks/useCurrentPage';

const propTypes = {
  isEditable: PropTypes.bool.isRequired,
  text: PropTypes.string,
  href: PropTypes.string,
  className: PropTypes.string,
  invertColors: PropTypes.bool,
  target: PropTypes.string,
};

const defaultProps = {
  text: 'Add Text',
  href: '',
  invertColors: false,
  className: undefined,
  target: '_self',
};

const Button = ({
  text,
  href,
  isEditable,
  className,
  invertColors,
  target,
}) => {
  const {
    secondaryColorBackgroundClass,
    primaryColorBackgroundHoverClass,
    primaryColorBackgroundClass,
    secondaryColorBackgroundHoverClass,
    buttonStyleClass,
  } = useCurrentPage();

  const classes = ['themed-button'];
  if (buttonStyleClass) {
    classes.push(buttonStyleClass);
  }
  if (className) {
    classes.push(className);
  } else if (invertColors) {
    classes.push(secondaryColorBackgroundClass);
    classes.push(primaryColorBackgroundHoverClass);
  } else {
    classes.push(primaryColorBackgroundClass);
    classes.push(secondaryColorBackgroundHoverClass);
  }

  return (
    <BaseButton
      href={isEditable ? '' : href}
      className={classes.join(' ')}
      block
      variant="primary"
      target={target}
    >
      {text}
    </BaseButton>
  );
};

Button.propTypes = propTypes;

Button.defaultProps = defaultProps;

export default Button;
